export const READ_ABANDON_WALLET = 'READ_ABANDON_WALLET';
export const WRITE_ABANDON_WALLET = 'WRITE_ABANDON_WALLET';
export const READ_ABANDON_WALLET_TXN = 'READ_ABANDON_WALLET_TXN';
export const READ_ABANDON_ORDER = 'READ_ABANDON_ORDER';